import styled, { css } from 'styled-components'

const CustomMenuContainer = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
            display: flex;
            max-width: 100vw;
            position: fixed;
            bottom: 0px;
            left: 0px;
            width: 100vw;
            align-items: center;
            justify-content: space-between;

            @media ${device.tabletM} {
                min-height: 100vh;
                height: 100vh;
                width: 107px;
                left: 0%;
            }
        `;
    }}
`;

const MenuBackground = styled.svg`
${({ theme }) => {
        const { device } = theme;
        return css`
        height: 77px;
        width: 100vw;
        background: #00B9E1;
        @media ${device.tabletM} {
            height: 100%;
        }
    `;
    }}
`;

const IconsContainer = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
            display: flex;
            align-items: center;
            // justify-content: space-around;
            position: absolute;
            width: 100vw;
            padding-bottom: 52px;
            @media ${device.tabletM} {
                height: 710px;
                width: 100%;
                flex-direction: column;
                justify-content: space-around;
                align-content: space-between;
                top: 127px;
                left: 52px;
            }
        `;
    }}
`;

const IconsContainer02 = styled(IconsContainer)`
${({ theme }) => {
        const { device } = theme;
        return css`
        display: none;
        @media ${device.tabletM} {
            display: flex;
            font-family: Noto Sans KR;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            text-align: -webkit-right;
            color: #FFFFFF;
            height: 780px;
            width: 72px;
            flex-direction: column;
            justify-content: space-around;
            align-content: space-between;
            top: 168px;
            left: 30px;
        }
            }
        `;
    }}
`;

const MudIcon = styled.img`
${(props) => {
        return css`
        width: 50px;
        height: 50px;
        background: #fff;
        border-radius: 50%;
        z-index: 101;
        cursor: pointer;
        position: absolute;
        left: ${props.left ? props.left : ''}px;
        @media (min-width:806px) {
            width: 70px;
            height: 70px;
            position: absolute;
            top: 43px;
            left: 0;
        }
        ${(props) => props.selected &&
                css`
                transform: translateY(-16px);
                transition-duration: 0.3s;
                @media (min-width:806px) {
                    position: absolute;
                    top: 43px;
                    transform: translateX(43px);
                    transition-duration: 0.3s;
                }
        `
            }
    `;
    }}
`;


const SaltIcon = styled.img`
${(props) => {
        return css`
        width: 50px;
        height: 50px;
        background: #fff;
        border-radius: 50%;
        z-index: 101;
        cursor: pointer;
        position: absolute;
        left: 32%;
        @media (min-width:806px) {
            width: 70px;
            height: 70px;
            position: absolute;
            top: 218px;
            left: 0;
        }
        ${(props) => props.selected &&
                css`
                transform: translateY(-16px);
                transition-duration: 0.3s;
            @media (min-width:806px) {
                position: absolute;
                top: 218px;
                transform: translateX(43px);
                transition-duration: 0.3s;
            }
    `
            }
    `;
    }}
`;


const SeaweedIcon = styled.img`
${(props) => {
        return css`
        width: 50px;
        height: 50px;
        background: #fff;
        border-radius: 50%;
        z-index: 101;
        cursor: pointer;
        position: absolute;
        right: 32%;
        @media (min-width:806px) {
            width: 70px;
            height: 70px;
            position: absolute;
            top: 392px;
            left: 0;
        }
        ${(props) => props.selected &&
                css`
            transform: translateY(-16px);
            transition-duration: 0.3s;
            @media (min-width:806px) {
                position: absolute;
                top: 392px;
                transform: translateX(43px);
                transition-duration: 0.3s;
            }
    `
            }
    `;
    }}
`;

const BoardIcon = styled.img`
${(props) => {
        return css`
        width: 50px;
        height: 50px;
        background: #fff;
        border-radius: 50%;
        z-index: 101;
        cursor: pointer;
        position: absolute;
        right: 40px;
        @media (min-width:806px) {
            width: 70px;
            height: 70px;
            position: absolute;
            top: 584px;
            left: 0;
        }
        ${(props) => props.selected &&
                css`
            transform: translateY(-16px);
            transition-duration: 0.3s;
            @media (min-width:806px) {
                position: absolute;
                top: 584px;
                transform: translateX(43px);
                transition-duration: 0.3s;
            }
    `
            }
    `;
    }}
`;

const BackIcon = styled.div`
${(props) => {
        return css`
        width: 66px;
        height: 66px;
        background: #fff;
        border: 8px solid #fff;
        border-radius: 50%;
        cursor: pointer;
        position: absolute;
        left: ${props.left ? props.left : ''}px;
        transform: translateY(-16px);
        transition-duration: 0.3s;
        @media (min-width:806px) {
            width: 90px;
            height: 90px;
            position: absolute;
            top: ${props.top ? props.top : ''}px;
            border: 10px solid #fff;
            transition-delay: 0.5s;
            transform: translateY(0px);
        }
    `;
    }}
`;

const BackIcon03 = styled(BackIcon)`
${(props) => {
        return css`
        left: 30.5%;
        transform: translateY(-16px);
        transition-duration: 0.3s;
        @media (min-width:806px) {
            width: 90px;
            height: 90px;
            position: absolute;
            top: 210px;
            left: 32px;
            border: 10px solid #fff;
            transform: translateY(0px);
        }
    `;
    }}
`;

const BackIcon02 = styled(BackIcon)`
${(props) => {
        return css`
        right: 31%;
        transform: translateY(-16px);
        transition-duration: 0.3s;
        @media (min-width:806px) {
            width: 90px;
            height: 90px;
            position: absolute;
            border: 10px solid #fff;
            left: 32px;
            top: 383px;
            transform: translateY(0px);
        }
    `;
    }}
`;

const BackIcon04 = styled(BackIcon)`
${(props) => {
        return css`
        right: ${props.right ? props.right : ''}px;
        transform: translateY(-16px);
        transition-duration: 0.3s;
        @media (min-width:806px) {
            width: 90px;
            height: 90px;
            position: absolute;
            border: 10px solid #fff;
            left: 32px;
            top: 573px;
            transform: translateY(0px);
        }
    `;
    }}
`;

const styledComponents = { MudIcon, SeaweedIcon, SaltIcon, BoardIcon, BackIcon, BackIcon02, BackIcon03, BackIcon04, IconsContainer, CustomMenuContainer, MenuBackground, IconsContainer02 };

export default styledComponents;